<template>
  <div class="vacancies-page">
    <Breadcrumbs :links="breadCrumbsLinks"/>

    <div class="container page__columns">
      <div class="container-inner">
        <ErrorView
          v-if="isNoVacancies && !haveSearch"
          no-set-meta
          :title="$tVacancies('Vacancies not found')"
        />
        <template v-else>
          <div class="page__columns-inner">
            <div v-if="!smOrDown" class="page__side-col">
              <div class="page__side-col-inner">
                <SideFilter class="page__side-col-item  _filter"/>
                <SideViewedVacancies
                  v-show="show.viewedVacancies"
                  class="page__side-col-item _viewed-vacancies"
                />
              </div>
            </div>

            <main class="page__main-col vacancies-page__results-wrap">
              <VacanciesResult @loadend="onVacanciesLoadEnd" />
            </main>

            <div
              v-if="smOrDown"
              class="vacancies-page__vacancies-viewed-wrap"
            >
              <ViewedVacancies
                v-show="show.viewedVacancies"
                class="vacancies-page__vacancies-viewed"
              />
            </div>
          </div>

          <SeoBlock
            :link="seoLink"
            class="vacancies-page__seo"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions, mapGetters} from "vuex";
  import Breadcrumbs from "../components/Breadcrumbs";
  import SideFilter from "../components/mainFilter/MainFilter";
  import SideViewedVacancies from "../components/SideViewedVacancies";
  import ViewedVacancies from "../components/ViewedVacancies";
  import windowSizeMixin from '../mixins/windowSizeMixin'
  import VacanciesResult from "../components/VacanciesResult";
  import SeoBlock from "../components/SeoBlock";
  import ErrorView from "../components/ErrorView";
  import capitalize from '@/helpers/capitalize'
  import globalMetaMixin from '../mixins/globalMetaMixin'
  import {setReferralToLocalstorage} from '@/mixins/authMixin'
  import {
    openModalsWeFindYouWork,
    stopOpenModalsWeFindYouWork
  }
    from '@/services/modalsAutoShow'

  export default {
    mixins: [windowSizeMixin, globalMetaMixin],
    components: {
      VacanciesResult,
      SideViewedVacancies,
      ViewedVacancies,
      SideFilter,
      Breadcrumbs,
      SeoBlock,
      ErrorView,
    },
    data() {
      return {
        show: {
          viewedVacancies: false,
        },
      };
    },
    computed: {
      ...mapState('vacancies', [
        'total',
        'pending',
        'vacancies',
        'dynamicFilters',
        'dynamicRouteFilters',
        'profession',
        'country',
        'city',
        'staticRouteFilters',
        'otherKeys',
        'metaTitle',
        'metaDescription',
      ]),
      ...mapGetters('vacancies', [
        'params',
        'dynamicFiltersItems',
        'hasStaticRouteFilters',
        'hasDynamicRouteFilters',
      ]),
      isNoVacancies() {
        return !this.pending && (!this.vacancies.length || !this.total)
      },
      haveSearch() {
        return !!this.params[this.otherKeys.SEARCH]
      },
      seoLink() {
        if (this.$route.query.page > 1) return null
        return 'https://jobian.com' + this.$route.fullPath
      },
      breadCrumbsLinks() {
        const links = [{
          name: this.$tVacancies('Vacancies')
        }]

        if (this.profession) {
          links[0].href = '/vacancies/'
          links[0].route = {
            name: 'vacancies'
          }

          links.push({
            name: this.profession.category.title
          })
        }
        return links
      },

      // - - - - -

      selectedCategories() {
        const ids = this.$route.params.professionsIds || []
        return this.categoriesList.filter(item => ids.includes(item.category.slug))
      },
      searchValue() {
        return this.$route.query.search_query
      },

      // - - - - -


      dynamicFiltersItemsFormat() {
        return (this.dynamicFiltersItems || []).map(item => {
          return `${item.group.title} - ${item.title}`
        })
      },

      metaFilterParams() {
        let params = []

        if (this.country) {
          params.push(`${this.$tFilter('Country')} - ${this.country.name}`)
        }

        if (this.city) {
          params.push(`${this.$tFilter('City')} - ${this.city.name}`)
        }

        params = params.concat(this.dynamicFiltersItemsFormat)

        return params.join(', ')
      },

      metaTitleComputed() {
        if (this.metaTitle) {
          return this.metaTitle
        }

        let page = this.$route.query.page > 1 ?
            ` ${this.$tMeta('- страница')} ${this.$route.query.page}` : ''

        let title = []

        if (this.profession) {
          let profession = this.profession.category.title
          title.push(
              this.$tMeta('vacancies-profession-meta-title-prefix') + ' ' + profession
          )
        }

        if (this.metaFilterParams) {
          if (!title.length) {
            title.push(this.$tMeta('vacancies-meta-title-prefix'))
          }

          title.push(this.metaFilterParams)
        }

        title = title.join(', ')

        if (title.length) {
          if (this.profession) {
            title += ' ' + this.$tMeta('vacancies-profession-meta-title-suffix')
          } else {
            title += ' ' + this.$tMeta('vacancies-meta-title-suffix')
          }

          return title + page
        }

        return this.$tMeta('vacancies-meta-title') + page
      },
      metaDescriptionComputed() {
        if (this.metaDescription) {
          return this.metaDescription
        }

        let page = this.$route.query.page > 1 ?
            ` ${this.$tMeta('Страница')} ${this.$route.query.page}.` : ''

        let description = []

        if (this.profession) {
          let profession = this.profession.category.title
          description.push(capitalize(profession))
        }

        if (this.metaFilterParams) {
          if (!description.length) {
            description.push(this.$tMeta('vacancies-meta-description-prefix'))
          }

          description.push(this.metaFilterParams)
        }

        description = description.join(', ')

        if (description.length) {
          description += ' ' + this.$tMeta('vacancies-meta-description-suffix')

          return description + page
        }

        return this.$tMeta('vacancies-meta-description') + page
      }
    },
    methods: {
      ...mapMutations('vacancies', [
        'updateRouteFilters',
      ]),
      ...mapActions('vacancies', [
        'load',
      ]),

      setMeta() {
        const title = this.metaTitleComputed
        const description = this.metaDescriptionComputed

        this.setMetaTitleMixin(title)
        this.setMetaDescriptionMixin(description)
        this.setOpenGraph({
          title: title,
          description: description,
        })
      },
      scrollToTop() {
        document.body.scrollIntoView(true);
      },
      onVacanciesLoadEnd() {
        this.show.viewedVacancies = true;
      },
    },
    created() {
      this.setMeta()

      const referralCode = this.$route.query.referal_code
      if (referralCode) {
        setReferralToLocalstorage(referralCode)
      }

      this.updateRouteFilters(this.$route)
      this.load()
    },
    mounted() {
      openModalsWeFindYouWork(30000, 'vacancies', () => {
        return !this.hasStaticRouteFilters && !this.hasDynamicRouteFilters
      })
    },
    beforeDestroy() {
      stopOpenModalsWeFindYouWork()
    },
    watch: {
      '$route'(to) {
        this.updateRouteFilters(to)
        this.load()
        this.scrollToTop();
      },

      metaTitleComputed() {
        this.setMeta()
      },
    }
  }
</script>

<style lang="less">

</style>
